import { DataVizContainerViewConfigWithStateManager } from '../../../common/types';
import {
  TimePeriodSegmentedVizData,
  TimePeriodSegmentedVizExternalProps,
} from '../../types';
import { timePeriodSegmentedBarChartDataToUiComponentProps } from './dataToUiComponentProps';
import {
  TimePeriodSegmentedBarChartActions,
  TimePeriodSegmentedBarChartState,
  TimePeriodSegmentedBarChartUiComponentProps,
} from './types';
import { TimePeriodSegmentedBarChartUiComponent } from './UiComponent';
import { useTimePeriodSegmentedBarChartStateManager } from './useStateManager';

export const timePeriodSegmentedBarChartViewConfig: DataVizContainerViewConfigWithStateManager<
  TimePeriodSegmentedVizData,
  TimePeriodSegmentedVizExternalProps,
  TimePeriodSegmentedBarChartUiComponentProps,
  TimePeriodSegmentedBarChartState,
  TimePeriodSegmentedBarChartActions
> = {
  hasStateManager: true,
  useStateManager: useTimePeriodSegmentedBarChartStateManager,
  dataToUiComponentProps: timePeriodSegmentedBarChartDataToUiComponentProps,
  UiComponent: TimePeriodSegmentedBarChartUiComponent,
};
